<div class="status-left">
  <glxy-uploader-file-status *ngIf="status" [status]="status"></glxy-uploader-file-status>

  <span class="file-name" *ngIf="!url">{{ name }}</span>
  <a class="file-name" *ngIf="url" [href]="url" rel="noopener noreferrer" target="_blank">
    {{ name }}
  </a>
</div>

<button *ngIf="deleted.observers.length > 0" mat-icon-button (click)="deleteClick()">
  <mat-icon class="delete-button-icon">add_circle_outline</mat-icon>
</button>
